import { motion } from "framer-motion";
import TextType from "../js/TextType";
import WelcomeImg from "../assests/welcomeImg.gif";
// Make sure to import the new background you created!
import Background from "../assests/background.png";
import styles from "./Welcome.css"; // Import the CSS Module
import { AuthContext } from "../context/AuthContext";
import { useContext } from "react";

// Animation variants for the container and its children
const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.3, // Animates children one after another with a 0.3s delay
        },
    },
};

const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
        y: 0,
        opacity: 1,
        transition: { type: "spring", stiffness: 100 },
    },
};


export default function Welcome() {

    const { authData } = useContext(AuthContext)
    const isMobile = window.innerWidth < 768;

    const firstName = authData?.employee?.first_name || "";
    const lastName = authData?.employee?.last_name || "";

    return (
        <center>
            <motion.section
                className={styles.welcomeContainer}
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >

                <div className={styles.contentWrapper}>

                    <motion.div variants={itemVariants}>
                        <TextType
                            text={[
                                `WELCOME ${firstName.toUpperCase()} ${lastName.toUpperCase()}`,
                            ]}
                            typingSpeed={75}
                            pauseDuration={1500}
                            showCursor={true}
                            cursorCharacter="|"
                            className={styles.welcomeTitle}
                        />
                    </motion.div>

                    {
                        isMobile ? (
                            <motion.img
                                src={WelcomeImg}
                                alt="Welcome Animation"
                                className={styles.welcomeImage}
                                variants={itemVariants}
                                style={{width:'300px', height:'400px'}}
                            />
                        ) : (
                            <motion.img
                                src={WelcomeImg}
                                alt="Welcome Animation"
                                className={styles.welcomeImage}
                                variants={itemVariants}
                            />
                        )
                    }

                </div>
            </motion.section>
        </center>

    );
}